import {
  ADMIN_ACCESS_ITEMS,
  SIDEBAR_ITEMS,
  createAdminPermissionState,
} from "../assets/instateamMasterConfig";

export function normalizeAdminPermissions(rawPermissions) {
  const allEnabled = createAdminPermissionState(true);

  if (!rawPermissions || typeof rawPermissions !== "object") {
    return allEnabled;
  }

  const keys = Object.keys(rawPermissions);
  if (!keys.length) {
    return allEnabled;
  }

  return ADMIN_ACCESS_ITEMS.reduce((accumulator, item) => {
    accumulator[item.key] = Boolean(rawPermissions[item.key]);
    return accumulator;
  }, createAdminPermissionState(false));
}

export function filterAccessibleSidebarItems(permissions) {
  const safePermissions = normalizeAdminPermissions(permissions);

  return SIDEBAR_ITEMS.filter(
    (item) => safePermissions[item.permissionKey] !== false
  );
}

export function canAccessAdminFeature(permissions, key) {
  if (!key) return true;
  const safePermissions = normalizeAdminPermissions(permissions);
  return Boolean(safePermissions[key]);
}

export function getFirstAccessibleAdminView(permissions, fallback = "profile") {
  const safePermissions = normalizeAdminPermissions(permissions);
  const priority = [
    "employees",
    "departments",
    "designations",
    "attendance",
    "leaves",
    "payroll",
    "documents",
    "chat",
    "complaints",
    "announcements",
    "dashboard",
    "tasks",
    "reports",
    "settings",
  ];

  for (const key of priority) {
    if (safePermissions[key]) {
      return key;
    }
  }

  return fallback;
}
